import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom/client';

import BaseWrappers from './BaseWrappers';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BaseWrappers>
        <App />
      </BaseWrappers>
    </LocalizationProvider>
  </React.StrictMode>,
);
